<template>
    <bottom-sheet>
        <template #title>
            <span>Re-enable {{ currentAsset.symbol }}</span>
        </template>

        <sheet-section label="Written off">
            <template v-if="disableRecord">
                <record-row>
                    <div class="mono">{{ disableRecord.value_released ? formatAmount(disableRecord.value_released) : '' }}</div>
                    <div class="mono">{{ formatPrice(disableRecord.exit_price) }}</div>
                    <div class="record-date">{{ formatTimeFromISO(disableRecord.disabled_at) }}</div>
                </record-row>
                <form-row>
                    <template #label>
                        <label for="reopen-positions" class="reopen-label">Reopen positions</label>
                    </template>
                    <b-form-checkbox id="reopen-positions" v-model="reopenPositions" switch />
                </form-row>
            </template>
            <div v-else class="sheet-muted-row">No write-off recorded</div>
        </sheet-section>

        <template #actions>
            <button type="button" class="sheet-btn sheet-btn-success" :disabled="busy" @click="onSubmit">
                <b-spinner v-if="busy" small type="grow" />
                <span v-else>Re-enable {{ currentAsset.symbol }}</span>
            </button>
        </template>

        <confirm-prompt
            :visible="confirmVisible"
            :title="`Re-enable ${currentAsset.symbol}`"
            :message="confirmMessage"
            :confirm-label="`Re-enable ${currentAsset.symbol}`"
            confirm-variant="btn-success"
            @confirm="confirmEnable"
            @cancel="cancelEnable"
        />
    </bottom-sheet>
</template>

<script>

import apiMixin from '@/mixins/api';
import formatter from '@/mixins/formatter';
import ConfirmPrompt from '@/components/overlays/ConfirmPrompt.vue';
import BottomSheet from '@/components/sheet/BottomSheet.vue';
import SheetSection from '@/components/sheet/SheetSection.vue';
import RecordRow from '@/components/sheet/RecordRow.vue';
import FormRow from '@/components/sheet/FormRow.vue';

export default {
    name: 'EnableAsset',
    mixins: [apiMixin, formatter],
    props: ['currentAsset', 'onDone'],
    components: { ConfirmPrompt, BottomSheet, SheetSection, RecordRow, FormRow },
    data() {
        return {
            reopenPositions: false,
            busy: false,
            confirmVisible: false,
        }
    },
    computed: {
        disableRecord() {
            const disables = this.currentAsset.meta?.disables;
            if (!disables) return null;

            for (let i = disables.length - 1; i >= 0; i--) {
                if (!disables[i].enabled_at) return disables[i];
            }

            return null;
        },
        confirmMessage() {
            const reopenNote = (this.reopenPositions && this.disableRecord)
                ? 'It also reopens the written-off positions.'
                : 'It does not reopen any positions.';

            return `Re-enable ${this.currentAsset.symbol}? This discards its frozen sell-off snapshot. ${reopenNote}`;
        },
    },
    methods: {
        onSubmit() {
            if (this.busy) return;
            this.confirmVisible = true;
        },
        cancelEnable() {
            this.confirmVisible = false;
        },
        async confirmEnable() {
            this.confirmVisible = false;

            if (this.busy) return;
            this.busy = true;

            const response = await this.apiPost(
                `/api/asset/${this.currentAsset.symbol}/enable`,
                { reopen_positions: this.reopenPositions }
            );

            this.busy = false;

            if (!response) return;

            this.$store.dispatch('updateAssets', [response.data.asset]);
            const message = response.data.reopened_count
                ? `Reopened ${response.data.reopened_count} positions.`
                : 'Re-enabled. No positions were reopened.';
            this._apiSuccessToast(message);
            this.$FModal.hide();
            if (this.onDone) this.onDone();
        },
    },
};
</script>

<style scoped>
.reopen-label {
    margin: 0;
    cursor: pointer;
}
/* the label covers the whole row, so a tap anywhere on it moves the switch */
.reopen-label::after {
    content: '';
    position: absolute;
    inset: 0;
}
</style>
